import {INIT_INDEX} from 'util/constants';
import {readColors} from 'config/highcharts';
import {byteUtils} from 'util/bytes.js';

import 'style/_colors.scss';

const CHART_BACKUPS_SMALL = 300;

/* eslint-disable no-magic-numbers */
/* eslint-disable no-template-curly-in-string */
/* eslint-disable max-params */
/**
 * Big monthly chart
 * @type Object
 */
export const getChartMonth = (legendEvent, loadEvent, clickEvent) => ({
    chart: {
        type:   'areaspline',
        events: {
            load: loadEvent
        },
        resetZoomButton: {
            theme: {
                display: 'none'
            }
        },
        height:   300,
        zoomType: 'x'
    },
    title:  null,
    legend: {
        layout:        'horizontal',
        align:         'center',
        verticalAlign: 'bottom',
        floating:      false
    },
    xAxis: {
        gridLineWidth: 0,
        tickInterval:  1,
        labels:        {
            formatter() {
                return this.value;
            }
        },
        allowDecimals: false
    },
    yAxis: {
        title: null
    },
    tooltip: {
        shared:       true,
        headerFormat: '',
        pointFormat:  '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>${point.y:.2f}</b><br/>'
    },
    plotOptions: {
        areaspline: {

            stacking:    'normal',
            fillOpacity: 0.4,
            lineWidth:   1,
            marker:      {
                radius: 3
            }
        },
        series: {
            cursor:      'pointer',
            trackByArea: true,
            events:      {
                hide:  legendEvent,
                show:  legendEvent,
                click: clickEvent
            }
        }
    }
});
/**
 * Last Year chart
 * @type Object
 */
export const getChartYear = () => ({
    chart: {
        type:    'column',
        spacing: [10, 0, 0, 0],
        height:  210
    },
    title:  null,
    legend: {
        layout:        'horizontal',
        align:         'center',
        verticalAlign: 'bottom',
        floating:      false,
        itemStyle:     {
            fontSize: '12px'
        }
    },
    xAxis: {
        gridLineColor: '#ddd',
        gridLineWidth: 0,
        /*        plotBands: [{
            from: 10.5,
            to: 11.5,
            color: 'rgba(68, 170, 213, .1)'
        }],*/
        type:          'category',
        categories:    []
    },
    yAxis: {
        title: null
    },
    tooltip: {
        shared:       true,
        headerFormat: '',
        pointFormat:  '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>${point.y:.2f}</b><br/>'
    },
    plotOptions: {
        column: {
            stacking:    'normal',
            fillOpacity: 0.4,
            lineWidth:   1,
            marker:      {
                radius: 3
            }
        }
    }
});
/**
 * Top Pie Charts
 * @type Object
 */
export const getChartTop = () => ({
    chart: {
        type: 'pie'
    },
    title:  null,
    legend: {
        layout:        'horizontal',
        align:         'center',
        verticalAlign: 'bottom',
        floating:      false
    },
    /*tooltip: {
     shared: true,
     valueSuffix: '%'
     },*/
    plotOptions: {
        pie: {
            fillOpacity: 0.4,
            dataLabels:  {
                enabled: false,
                format:  '{point.percentage:.1f} %'
            }
        }
    },
    tooltip: {
        headerFormat: '',
        pointFormat:  '<span style="color:{point.color}">{point.name}</span>: <b>${point.y:.2f}</b><br/>'
    },
    series: [{
        colorByPoint: true,
        innerSize:    '60%',
        data:         []
    }]
});
/**
 * DailyChart
 * @type Object
 */
export const getBackupsDailyChart = formatNumber => ({
    chart: {
        type:        'areaspline',
        zoomType:    'x',
        spacingLeft: 5

    },
    title:  null,
    legend: {
        layout:        'horizontal',
        align:         'center',
        verticalAlign: 'bottom',
        floating:      false
    },
    xAxis: {
        gridLineWidth: 0,
        tickInterval:  1,
        labels:        {
            enabled: true
        }
    },
    yAxis: {
        title:  null,
        labels: {
            align: 'right',
            formatter() {
                return byteUtils.convertBytesAndFormatWithSymbol(this.value, formatNumber);
            },
            distance: 0,
            enabled:  true,
            style:    {
                cursor:   'default',
                fontSize: '11px'
            },
            zIndex: 7
        }
    },
    tooltip: {
        shared:       true,
        headerFormat: '',
        pointFormat:  '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y:.2f} </b><br/>',
        formatter() {
            let toolTipString = '';

            this.points.forEach(point => {
                toolTipString += `<span style="color:${point.color}">\u25CF</span> 
                    ${point.series.name.charAt(0).toUpperCase() + point.series.name.slice(1)}: <b>
                    ${byteUtils.convertBytesAndFormatWithSymbol(point.y, formatNumber)}</b><br/>`;
            });

            return toolTipString;
        }
    },
    plotOptions: {
        areaspline: {
            fillOpacity: 0.4,
            lineWidth:   1,
            marker:      {
                radius: 3
            }
        },
        spline: {
            marker: {
                enabled: false
            }
        }
    }
});

/**
 * CPU Usage Chart
 * @type Object
 */
export const getCpuUsageChart = (categories, series, titleSeries, xLabelFormatter, yLabelFormatter, tooltipFormatter) => ({
    title: {
        text: null
    },
    chart: {
        type:        'areaspline',
        zoomType:    'x',
        spacingLeft: 5

    },
    tooltip: {
        formatter: tooltipFormatter
    },
    xAxis: {
        categories,
        type:          'datetime',
        gridLineWidth: 0,
        labels:        {
            step:      6,
            formatter: xLabelFormatter
        }
    },
    yAxis: {
        title:  false,
        labels: {
            formatter: yLabelFormatter
        }
    },
    legend: {
        enabled: false
    },
    plotOptions: {
        area: {
            fillOpacity: 0.4
        },
        series: {
            animation: {
                duration: 2000
            }
        }
    },
    series: [{
        name: titleSeries,
        data: series,
        type: 'area'
    }]
});

/**
 * Top 10 host backups chart
 * @type {Array}
 */
export const getTop10HostBackupChart = formatNumber => ({
    chart: {
        type:   'column',
        height: CHART_BACKUPS_SMALL
    },
    title: null,
    xAxis: {
        gridLineColor: '#ddd',
        gridLineWidth: 0,
        type:          'category'
    },
    yAxis: {
        title:  null,
        labels: {
            formatter() {
                return byteUtils.convertBytesAndFormatWithSymbol(this.value, formatNumber);
            }
        }
    },
    legend: {
        enabled: false
    },
    tooltip: {
        shared: true,
        formatter() {
            /* eslint-disable no-useless-concat */
            return `<span style="color:${this.points[0].color}">\u25CF</span> ${this.points[0].key}: ` + ` 
            <b>${byteUtils.convertBytesAndFormatWithSymbol(this.points[0].series.data[this.x].y, formatNumber)} </b>`;
            /* eslint-enable no-useless-concat */
        }
    },
    plotOptions: {
        column: {
            stacking:    'normal',
            fillOpacity: 0.4,
            lineWidth:   1,
            marker:      {
                radius: 3
            }
        }
    }
});


/**
 * Last 13 months chart
 * @type Object
 */
export const getLast13MonthsChart = formatNumber => ({
    chart: {
        type:    'column',
        spacing: [10, 0, 0, 0],
        height:  CHART_BACKUPS_SMALL
    },
    title:  null,
    legend: {
        layout:        'horizontal',
        align:         'center',
        verticalAlign: 'bottom',
        floating:      false,
        itemStyle:     {
            fontSize: '12px'
        }
    },
    xAxis: {
        gridLineColor: '#ddd',
        gridLineWidth: 0,
        type:          'category'
    },
    yAxis: {
        title:  null,
        labels: {
            formatter() {
                return byteUtils.convertBytesAndFormatWithSymbol(this.value, formatNumber);
            }
        }
    },
    tooltip: {
        shared: true,


        formatter() {
            let toolTipString = '';

            this.points.forEach((point, index) => {
                const monthString = this.points[0].key.charAt(0).toUpperCase() + this.points[0].key.slice(1);
                const averageString = point.series.name.charAt(0).toUpperCase() + point.series.name.slice(1);

                toolTipString += `<span style="color:${point.color}">\u25CF</span> 
                    ${index === 0 ? monthString : averageString}: <b>
                    ${byteUtils.convertBytesAndFormatWithSymbol(point.y, formatNumber)}</b><br/>`;
            });

            return toolTipString;
        }
    },
    plotOptions: {
        column: {
            stacking:    'normal',
            fillOpacity: 0.4,
            lineWidth:   1,
            marker:      {
                radius: 3
            }
        },
        spline: {
            marker: {
                enabled: false
            }
        }
    }
});

const colors = readColors();

export const getColors = num => {
    if (colors.length < num) {
        colors.push.apply(colors, colors);

        return getColors(num);
    }

    return colors.slice(INIT_INDEX, num);
};

const formatMonthDate = value => {
    const date = new Date(value);
    let h = date.getUTCHours();
    let m = date.getUTCMinutes();
    let day = date.getUTCDate();

    h = h < 10 ? `0${h}` : h;
    m = m < 10 ? `0${m}` : m;
    day = day < 10 ? `0${day}` : day;

    return `${day} - ${h}:${m}`;
};

const formatMonthDateTooltip = value => {
    const date = new Date(value);
    const year = date.getUTCFullYear();
    let day = date.getUTCDate();
    let month = date.getUTCMonth() + 1;

    day = day < 10 ? `0${day}` : day;
    month = month < 10 ? `0${month}` : month;

    return `${day}/${month}/${year}`;
};

export const getInternetTrafficMonthlyChart = formatNumber => ({
    chart: {
        type:        'areaspline',
        zoomType:    'x',
        spacingLeft: 5

    },
    title:  null,
    legend: {
        layout:        'horizontal',
        align:         'center',
        verticalAlign: 'bottom',
        floating:      false
    },
    xAxis: {
        gridLineWidth: 0,
        tickInterval:  1,
        labels:        {
            enabled: true,
            formatter() {
                return formatMonthDate(this.value);
            }
        }
    },
    yAxis: {
        title:  null,
        labels: {
            align:    'right',
            distance: 0,
            enabled:  true,
            style:    {
                cursor:   'default',
                fontSize: '11px'
            },
            zIndex: 7
        }
    },
    tooltip: {
        formatter() {
            return `${formatMonthDateTooltip(this.point.x)}<br><span style="color:${this.point.color}">\u25CF</span>
            <b>${this.series.name}<b/>: ${byteUtils.convertBytesAndFormatWithSymbol(this.y, formatNumber)}`;
        }
    },
    plotOptions: {
        areaspline: {
            fillOpacity: 0.4,
            lineWidth:   1,
            marker:      {
                radius: 3
            }
        },
        spline: {
            marker: {
                enabled: false
            }
        }
    }
});

const formatDailyDate = value => {
    const date = new Date(value);
    const year = date.getUTCFullYear();
    let day = date.getUTCDate();
    let month = date.getUTCMonth() + 1;

    let h = date.getUTCHours();
    let m = date.getUTCMinutes();

    day = day < 10 ? `0${day}` : day;
    month = month < 10 ? `0${month}` : month;
    h = h < 10 ? `0${h}` : h;
    m = m < 10 ? `0${m}` : m;

    return `${day}/${month}/${year} ${h}:${m}`;
};

const formatDailyDay = value => {
    const date = new Date(value);
    const day = date.getUTCDate();

    return day < 10 ? `0${day}` : day;
};

export const getInternetTrafficDailyChart = formatNumber => ({
    chart: {
        type:        'areaspline',
        zoomType:    'x',
        spacingLeft: 5

    },
    title:  null,
    legend: {
        layout:        'horizontal',
        align:         'center',
        verticalAlign: 'bottom',
        floating:      false
    },
    xAxis: {
        gridLineWidth: 0,
        tickInterval:  1,
        labels:        {
            enabled: true,
            formatter() {
                return formatDailyDay(this.value);
            }
        }
    },
    yAxis: {
        title:  null,
        labels: {
            align:    'right',
            distance: 0,
            enabled:  true,
            style:    {
                cursor:   'default',
                fontSize: '11px'
            },
            zIndex: 7,
            formatter() {
                return `${formatNumber(this.value)} Kbps`;
            }
        }
    },
    tooltip: {
        shared: true,
        formatter() {
            let tooltip = `${formatDailyDate(this.points[0].x)}`;

            this.points.forEach(point => {
                tooltip += `<br><span style="color:${point.color}">\u25CF</span><b>${point.series.name}<b/>: ${point.y} Kbps`;
            });

            return tooltip;
        }
    },
    plotOptions: {
        areaspline: {
            fillOpacity: 0.4,
            lineWidth:   1,
            marker:      {
                radius: 3
            }
        },
        spline: {
            marker: {
                enabled: false
            }
        }
    }
});

/* eslint-enable */



// WEBPACK FOOTER //
// ./src/util/charts.js